import { Button, Modal, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as React from 'react'
import styled from 'styled-components'
import { useUser } from '@/domain/user/hooks'
import { useIntl } from '@/intl'
import { LogoCompact } from '@/scopes/common/components/Logo'
import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common'
import { invalidateQueries, registerClient } from '@/scopes/common/infrastructure/query-client/queryClientsRegistry'

const ContentContainer = styled(SpaceBetween)`
  padding: ${tk('spacing_lg')};
  text-align: center;
`

export function CeModalWrapper() {
  const queryClient = new QueryClient()
  registerClient(queryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <CeModal />
    </QueryClientProvider>
  )
}

function CeModal() {
  const [isModalOpen, setIsModalOpen] = React.useState(true)
  const intl = useIntl()
  const { name, isSunwebCE } = useUser()
  const userAuthenticationClient = useCommonDependency('userAuthenticationClient')

  const onClose = () => {
    setIsModalOpen(false)
  }

  React.useEffect(() => {
    if (isSunwebCE) {
      userAuthenticationClient.invalidateUserInfo()
      invalidateQueries(['user'])
    }
  }, [isSunwebCE, userAuthenticationClient])

  if (!isSunwebCE || !name)
    return null

  return (
    <Modal.Root open={isModalOpen} onClose={onClose}>
      <Modal.Content $size="md">
        <Modal.Body>
          <ContentContainer direction="y" spacing={tk('spacing_lg')} alignItems="center">
            <LogoCompact />
            <Typography $variant="heading-md">
              {intl.formatMessage({ id: 'sunweb_ce_modal_title' }, { partnerName: name })}
            </Typography>
            <Typography $variant="body-md">{intl.formatMessage({ id: 'sunweb_ce_modal_paragraph_1' })}</Typography>
            <Typography>{intl.formatMessage({ id: 'sunweb_ce_modal_paragraph_2' })}</Typography>
            <Typography>{intl.formatMessage({ id: 'sunweb_ce_modal_paragraph_3' })}</Typography>
          </ContentContainer>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>{intl.formatMessage({ id: 'sunweb_ce_modal_close_text' })}</Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  )
}
